import { render, staticRenderFns } from "./menuSection.vue?vue&type=template&id=2b016616&scoped=true&"
import script from "./menuSection.vue?vue&type=script&lang=js&"
export * from "./menuSection.vue?vue&type=script&lang=js&"
import style0 from "./menuSection.vue?vue&type=style&index=0&id=2b016616&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b016616",
  null
  
)

export default component.exports